export default __webpack_public_path__ + "static/media/sms_icon_white.e55504b6.svg";